export class AttributeHeaders {
    public id: number;
    public attrHeader: String;
    public type: String;
    public categoryId: number;
    public subCategoryId: number;
    public description: String;
    public lastUpdate: Date;
    public updatedBy: String;
}



// WEBPACK FOOTER //
// ./src/app/models/attributeheaders.ts